import {
  mapDispatchToStoresWelcomeSectionProps,
  type WixStoreAddPanelDispatchProps,
} from '#packages/wixStore';
import { wrapWithPropsTransformer } from '../utils';

export interface StoresWelcomeProps {
  storesMainAction: () => void;
}

export const storesWelcomeMapper = wrapWithPropsTransformer<
  WixStoreAddPanelDispatchProps,
  StoresWelcomeProps
>(mapDispatchToStoresWelcomeSectionProps, (props) => ({
  storesMainAction: props.installApp,
}));
